<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>{{$t('extracurriculares.courses.page_title')}}</v-toolbar-title>
            <v-divider
                class="mx-2"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" @click="clean" v-on="on">{{$t('extracurriculares.courses.new_type')}}</v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span v-show="!editingcourses" class="headline">{{$t('extracurriculares.courses.new_type')}}</span>
                        <span v-show="editingcourses" class="headline">{{$t('extracurriculares.courses.edit_type')}}</span>
                    </v-card-title>

                    <v-card-text>

                        <v-autocomplete
                          :form="form"
                          v-model="form.siesa_service_id"
                          :loading="loading_courses"
                          :items="siesa_courses"
                          :search-input.sync="search_siesa_course"
                          cache-items
                          flat
                          hide-no-data
                          :label="$t('extracurriculares.courses.form.siesa_name')"
                          solo-inverted
                          v-validate="'required'"
                          data-vv-name="siesa_service_id"
                          :error-messages="errors.collect('siesa_service_id')"
                          name="Curso en SIESA"
                        ></v-autocomplete>

                        <v-autocomplete
                          :form="form"
                          v-model="form.siesa_cc"
                          :loading="loading_cc"
                          :items="cc"
                          :search-input.sync="search_cc"
                          flat
                          :label="$t('extracurriculares.courses.form.siesa_cc')"
                          solo-inverted
                          v-validate="'required'"
                          data-vv-name="siesa_cc"
                          :error-messages="errors.collect('siesa_cc')"
                          name="Centro de costos SIESA"
                        ></v-autocomplete>

                        <v-autocomplete
                          :form="form"
                          v-model="form.siesa_seller"
                          :loading="loading_seller"
                          :items="sellers"
                          :search-input.sync="search_seller"
                          cache-items
                          flat
                          hide-no-data
                          :label="$t('extracurriculares.courses.form.siesa_seller')"
                          solo-inverted
                          v-validate="'required'"
                          data-vv-name="siesa_seller"
                          :error-messages="errors.collect('siesa_seller')"
                          name="Vendedor SIESA"
                        ></v-autocomplete>

                        <v-autocomplete
                          :form="form"
                          v-model="form.siesa_id_motivo"
                          :loading="loading_motivo"
                          :items="motivos"
                          :search-input.sync="search_motivo"
                          cache-items
                          flat
                          hide-no-data
                          :label="$t('extracurriculares.courses.form.motivo')"
                          solo-inverted
                          v-validate="'required'"
                          data-vv-name="siesa_id_motivo"
                          :error-messages="errors.collect('siesa_id_motivo')"
                          name="siesa_id_motivo"
                        ></v-autocomplete>

                        <select-input
                          :form="form"
                          :items="course_types_items"
                          :label="$t('extracurriculares.courses.form.type')"
                          :v-errors="errors"
                          :value.sync="form.course_type_id"
                          name="course_type_id"
                          v-validate="'required'"
                        ></select-input>

                        <text-input
                            :form="form"
                            :label="$t('extracurriculares.courses.form.name')"
                            :v-errors="errors"
                            :value.sync="form.name"
                            name="name"
                            v-validate="'required'"
                        ></text-input>

                        <text-input
                            :form="form"
                            :label="$t('extracurriculares.courses.form.eng_name')"
                            :v-errors="errors"
                            :value.sync="form.eng_name"
                            name="eng_name"
                            v-validate="'required'"
                        ></text-input>

                        <check-input
                          name="provider_payment"
                          :form="form"
                          :label="$t('extracurriculares.courses.form.provider_payment')"
                          :value.sync="form.provider_payment"
                          :color="'primary'"
                          :v-errors="errors"
                        ></check-input>

                        <v-text-field
                            v-if="course_needs_price"
                            :form="form"
                            :label="$t('extracurriculares.courses.form.price')"
                            :v-errors="errors"
                            :value.sync="form.price"
                            v-model="form.price"
                            name="price"
                            v-validate="'required'"
                            v-money="money"
                        ></v-text-field>

                        <v-text-field
                            v-if="course_needs_price"
                            :form="form"
                            :label="$t('extracurriculares.courses.form.employee_discount')"
                            :v-errors="errors"
                            :value.sync="form.employee_discount"
                            v-model="form.employee_discount"
                            name="employee_discount"
                            v-validate="'required|min_value:0|max_value:100'"
                            v-money="number"
                        ></v-text-field>

                        <v-text-field
                            v-if="course_needs_price"
                            :form="form"
                            :label="$t('extracurriculares.courses.form.early_payment_discount')"
                            :v-errors="errors"
                            :value.sync="form.early_payment_discount"
                            v-model="form.early_payment_discount"
                            name="early_payment_discount"
                            v-validate="'required|min_value:0|max_value:100'"
                            v-money="number"
                        ></v-text-field>

                        <v-text-field
                            v-if="course_needs_price"
                            :form="form"
                            :label="$t('extracurriculares.courses.form.general_discount')"
                            :v-errors="errors"
                            :value.sync="form.general_discount"
                            v-model="form.general_discount"
                            name="general_discount"
                            v-validate="'required|min_value:0|max_value:100'"
                            v-money="number"
                        ></v-text-field>

                        <select-input
                          :form="form"
                          :items="periodicity_options"
                          :label="$t('extracurriculares.courses.form.periodicity')"
                          :v-errors="errors"
                          :value.sync="form.periodicity_number"
                          name="periodicity_number"
                          v-validate="'required'"
                        ></select-input>

                        <number-input
                            :form="form"
                            :label="$t('extracurriculares.courses.form.quota')"
                            :v-errors="errors"
                            :value.sync="form.quota"
                            name="quota"
                            v-validate="'required'"
                        ></number-input>

                        <radio-input
                          name="exclusion_type"
                          :form="form"
                          :items="this.exclusion_type"
                          :label="$t('extracurriculares.courses.form.exclusion_type')"
                          :v-errors="errors"
                          :value.sync="form.exclusion_type"
                          v-validate="'required'"
                          :color="'primary'"
                        >
                        </radio-input>

                        <select-multiple-input
                          v-if="form.exclusion_type === 'grade'"
                          :form="form"
                          :items="grades"
                          :label="$t('extracurriculares.courses.form.grades')"
                          :v-errors="errors"
                          :value.sync="form.grades_select"
                          name="grades_select"
                        ></select-multiple-input>

                        <select-multiple-input
                          v-if="form.exclusion_type === 'next_grade'"
                          :form="form"
                          :items="grades"
                          :label="$t('extracurriculares.courses.form.next_grade')"
                          :v-errors="errors"
                          :value.sync="form.grades_select"
                          name="grades_select"
                        ></select-multiple-input>

                        <v-layout row v-if="form.exclusion_type === 'age'">
                          <v-flex
                            shrink
                            style="width: 60px"
                          >
                            <v-text-field
                              v-model="age_range[0]"
                              class="mt-0"
                              hide-details
                              single-line
                              type="number"
                            ></v-text-field>
                          </v-flex>

                          <v-flex>
                            <v-range-slider
                              v-model="age_range"
                              :max="100"
                              :min="0"
                              :step="1"
                            ></v-range-slider>
                          </v-flex>

                          <v-flex
                            shrink
                            style="width: 60px"
                          >
                            <v-text-field
                              v-model="age_range[1]"
                              class="mt-0"
                              hide-details
                              single-line
                              type="number"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>

                        <select-multiple-input
                          :form="form"
                          :items="clothes_items"
                          :label="$t('extracurriculares.courses.form.clothes')"
                          :v-errors="errors"
                          :value.sync="form.clothes"
                          name="clothes"
                        ></select-multiple-input>

                        <div class="upload">
                          <ul>
                            <li v-for="(file) in videos" :key="file.id">
                              <span>{{file.name}}</span> -
                              <span>{{file.size}}</span>
                              &nbsp;&nbsp;&nbsp;
                              <span>
                                <v-tooltip top>
                                  <v-icon
                                    small
                                    class="mr-2"
                                    @click.prevent="$refs.videos.remove(file)"
                                    slot="activator"
                                  >
                                    delete
                                  </v-icon>
                                  <span>{{$t('extracurriculares.courses.delete')}}</span>
                                </v-tooltip>
                              </span>
                            </li>
                          </ul>
                          <div class="example-btn">
                            <file-upload
                              input-id="videos"
                              class="mb-2 v-btn theme--dark primary"
                              extensions="mp4,m4v,mov,flv"
                              accept="video/mp4,video/x-m4v,video/*"
                              :multiple="true"
                              :size="1024 * 1024 * 10"
                              v-model="videos"
                              @input-filter="inputFilterVideos"
                              @input-file="inputFileVideos"
                              ref="videos">
                              <i class="fa fa-plus"></i>
                              {{$t('extracurriculares.courses.form.videos')}}
                            </file-upload>

                          </div>
                        </div>

                        <div class="upload">
                          <ul>
                            <li v-for="(file) in photos" :key="file.id">
                              <span>{{file.name}}</span> -
                              <span>{{file.size}}</span>
                              &nbsp;&nbsp;&nbsp;
                              <span>
                                <v-tooltip top>
                                  <v-icon
                                    small
                                    class="mr-2"
                                    @click.prevent="$refs.photos.remove(file)"
                                    slot="activator"
                                  >
                                    delete
                                  </v-icon>
                                  <span>{{$t('extracurriculares.courses.delete')}}</span>
                                </v-tooltip>
                              </span>
                            </li>
                          </ul>
                          <div class="example-btn">
                            <file-upload
                              input-id="photos"
                              class="mb-2 v-btn theme--dark primary"
                              extensions="gif,jpg,jpeg,png,webp"
                              accept="image/png,image/gif,image/jpeg,image/webp"
                              :multiple="true"
                              :size="1024 * 1024 * 10"
                              v-model="photos"
                              @input-filter="inputFilterPhotos"
                              @input-file="inputFilePhotos"
                              ref="photos">
                              <i class="fa fa-plus"></i>
                              {{$t('extracurriculares.courses.form.photos')}}
                            </file-upload>

                          </div>
                        </div>

                        <select-input
                          :form="form"
                          :items="prerequisite_courses"
                          :label="$t('extracurriculares.courses.form.prerequisite')"
                          :v-errors="errors"
                          :value.sync="form.prerequisite_id"
                          name="prerequisite_id"
                          clearable
                        ></select-input>

                        <text-area-input
                            :form="form"
                            :label="$t('extracurriculares.courses.form.description')"
                            :v-errors="errors"
                            :value.sync="form.description"
                            name="description"
                            v-validate="'required'"
                        ></text-area-input>

                        <text-area-input
                            :form="form"
                            :label="$t('extracurriculares.courses.form.eng_description')"
                            :v-errors="errors"
                            :value.sync="form.eng_description"
                            name="eng_description"
                            v-validate="'required'"
                        ></text-area-input>

                        <check-input
                          name="status"
                          :form="form"
                          :label="$t('extracurriculares.courses.form.status')"
                          :value.sync="form.status"
                          :color="'primary'"
                          :v-errors="errors"
                        >
                        </check-input>

                        <check-input
                          name="no_validation"
                          :form="form"
                          :label="$t('extracurriculares.courses.form.no_validation')"
                          :value.sync="form.no_validation"
                          :color="'primary'"
                          :v-errors="errors"
                        >
                        </check-input>

                        <select-input
                          :form="form"
                          :items="public_options"
                          :label="$t('extracurriculares.courses.form.is_public')"
                          :v-errors="errors"
                          :value.sync="form.is_public"
                          name="is_public"
                          v-validate="'required'"
                        ></select-input>

                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="close">{{$t('extracurriculares.courses.form.cancel')}}</v-btn>
                        <v-btn v-if="!editingcourses" color="blue darken-1" flat @click="savecourses">{{$t('extracurriculares.courses.form.save')}}</v-btn>
                        <v-btn v-else color="blue darken-1" flat @click="updateCourseType">{{$t('extracurriculares.courses.form.update')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>
        <v-card-title>
          <v-layout row wrap>
            <v-flex xs3 px-1>
              <v-text-field
                v-model="search_filter"
                :label="$t('extracurriculares.register.search')"
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs3 px-1>
              <v-select
                v-model="type_filter"
                :items="course_types_items"
                :label="$t('extracurriculares.register.course_types')"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs3 px-1>
              <v-select
                v-model="grade_filter"
                :items="grades"
                :label="$t('extracurriculares.register.grades')"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs3 px-1>
              <v-select
                v-model="status_filter"
                :items="status_items"
                :label="$t('extracurriculares.courses.form.status')"
                clearable
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="courses_to_show"
            :loading="loadingTable"
            class="elevation-1"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.course_type.name }}</td>
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">{{ props.item.periodicity && $t(`extracurriculares.courses.form.periodicity_options['${props.item.periodicity}']`)}}</td>
                <td class="text-xs-center">${{ formatNumber(props.item.course_type.payment_type == 'course_payment' ? props.item.price : props.item.course_type.price) }}</td>
                <td class="text-xs-center">{{ props.item.course_type.payment_type == 'course_payment' ? props.item.employee_discount : props.item.course_type.employee_discount }}%</td>
                <td class="text-xs-center">{{ props.item.quota }}</td>
                <td class="text-xs-center">{{ props.item.grades }}</td>
                <td class="text-xs-center">{{ props.item.is_public == '1' ? 'Público' : props.item.is_public == '0' ? 'Privado' : 'Mixto' }}</td>
                <td class="text-xs-center">
                  <v-checkbox
                    :key="props.item.id"
                    :name="`check_${props.item.id}`"
                    :input-value="props.item.status"
                    @change="handleCourseStatus(props.item.id, props.item.status)"
                    color="primary"
                    class="center"
                  ></v-checkbox>
                </td>
                <td>
                  <div class="icons">
                    <v-tooltip top>
                      <v-icon
                        medium
                        class="mr-2"
                        @click="coursesPictures(props.item.id)"
                        slot="activator"
                      >
                        photo_library
                      </v-icon>
                      <span>{{$t('extracurriculares.courses.watch_pictures')}}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <v-icon
                        medium
                        class="mr-2"
                        @click="coursesVideos(props.item.id)"
                        slot="activator"
                      >
                        video_library
                      </v-icon>
                      <span>{{$t('extracurriculares.courses.watch_videos')}}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <v-icon
                        medium
                        class="mr-2"
                        @click="courseClothes(props.item.id)"
                        slot="activator"
                      >
                        accessibility
                      </v-icon>
                      <span>{{$t('extracurriculares.courses.watch_clothes')}}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <v-icon
                        medium
                        class="mr-2"
                        @click="courseSchedule(props.item.id)"
                        slot="activator"
                      >
                        schedule
                      </v-icon>
                      <span>{{$t('extracurriculares.courses.schedule')}}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <v-icon
                        medium
                        class="mr-2"
                        @click="courseTeachers(props.item.id)"
                        slot="activator"
                      >
                        local_library
                      </v-icon>
                      <span>{{$t('extracurriculares.courses.teachers')}}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <v-icon
                        medium
                        class="mr-2"
                        @click="courseRegistrationDates(props.item.id)"
                        slot="activator"
                      >
                        assignment
                      </v-icon>
                      <span>{{$t('extracurriculares.courses.registration_date')}}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <v-icon
                        medium
                        class="mr-2"
                        @click="editcourses(props.item.id)"
                        slot="activator"
                      >
                        edit
                      </v-icon>
                      <span>{{$t('extracurriculares.courses.edit')}}</span>
                    </v-tooltip>
                  </div>
                </td>
            </template>
        </v-data-table>
        <v-dialog v-model="filesDialog" max-width="500px">
          <template>
            <v-layout>
              <v-flex xs12>
                <v-card>
                  <v-container grid-list-sm fluid>
                    <v-layout row wrap>
                      <v-flex
                        v-for="(file, index) in courses_files"
                        :key="index"
                        xs6
                        d-flex

                      >
                        <v-card v-if="showPhotos">
                          <v-img

                            :src="file.file_url"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            height="150px"
                            width="150px"
                          >

                            <template v-slot:placeholder>
                              <v-layout
                                fill-height
                                align-center
                                justify-center
                                ma-0
                              >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-layout>
                            </template>
                          </v-img>
                          <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn @click="deleteCourseFile(file.id)" icon>
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-card-actions>
                        </v-card>
                        <v-card v-else>
                          <video
                            height="200px"
                            width="200px"
                            controls
                          >
                             <source :src="file.file_url" >
                          </video>
                          <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn @click="deleteCourseFile(file.id)" icon>
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-card-actions>
                        </v-card>

                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-card-actions>
                    <v-btn color="primary" flat @click="filesDialog=false">{{ $t('close') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </template>
        </v-dialog>
        <v-dialog v-model="clothesDialog" max-width="500px">
          <template>
            <v-layout>
              <v-flex xs12>
                <v-card>
                  <v-data-table
                    :headers="headersClothes"
                    :items="course_clothes"
                    :loading="loadingTable"
                    class="elevation-1"
                  >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-center">{{ props.item.clothe.name }}</td>
                    <td class="text-xs-center">
                      <v-tooltip top>
                        <v-icon
                          small
                          class="mr-2"
                          @click.prevent="removeCourseclothe(props.item.id)"
                          slot="activator"
                        >
                          delete
                        </v-icon>
                        <span>{{$t('extracurriculares.courses.delete')}}</span>
                      </v-tooltip>
                    </td>
                  </template>
                  </v-data-table>
                  <v-card-actions>
                    <v-btn color="primary" flat @click="clothesDialog=false">{{ $t('close') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </template>
        </v-dialog>
        <v-dialog full-width v-model="schedulesDialog" max-width="1000px">
          <template>
            <v-layout>
              <v-flex xs12>
                <v-card>
                  <v-card-text>

                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md3>
                          <text-input
                            :form="scheduleForm"
                            :label="$t('extracurriculares.courses.schedules.name')"
                            :v-errors="errors"
                            :value.sync="scheduleForm.name"
                            name="name"
                            v-validate="'required'"
                            data-vv-scope="schedule_form"
                          ></text-input>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <text-input
                            :form="scheduleForm"
                            :label="$t('extracurriculares.courses.schedules.eng_name')"
                            :v-errors="errors"
                            :value.sync="scheduleForm.eng_name"
                            name="eng_name"
                            v-validate="'required'"
                            data-vv-scope="schedule_form"
                          ></text-input>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <text-input
                            :form="scheduleForm"
                            :label="$t('extracurriculares.courses.schedules.description')"
                            :v-errors="errors"
                            :value.sync="scheduleForm.description"
                            name="description"
                          ></text-input>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <check-input
                            name="status"
                            :form="scheduleForm"
                            :label="$t('extracurriculares.courses.schedules.status')"
                            :value.sync="scheduleForm.status"
                            :color="'primary'"
                            :v-errors="errors"
                          ></check-input>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <check-input
                            name="transfer"
                            :form="scheduleForm"
                            :label="$t('extracurriculares.courses.schedules.transfer')"
                            :value.sync="scheduleForm.transfer"
                            :color="'primary'"
                            :v-errors="errors"
                          ></check-input>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <v-btn :loading="schedule_loading" :disabled="schedule_loading" v-if="!editingSchedule" color="primary" @click="saveSchedule">{{$t('extracurriculares.courses.schedules.add')}}</v-btn>
                          <div v-else>
                            <v-btn :loading="schedule_loading" :disabled="schedule_loading" color="primary" @click="updateSchedule">{{$t('extracurriculares.courses.schedules.update')}}</v-btn>
                            <v-btn color="primary" @click="cancelUpdateSchedule">{{$t('extracurriculares.courses.form.cancel')}}</v-btn>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>

                  </v-card-text>
                </v-card>
                <v-card>
                  <v-card-title>
                    <v-layout row wrap>
                      <v-flex xs3 px-1>
                        <v-select
                          v-model="status_filter_schedules"
                          :items="status_items"
                          :label="$t('extracurriculares.courses.form.status')"
                          clearable
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <v-data-table
                    :headers="headersSchedules"
                    :items="schedules_to_show"
                    :loading="loadingTable"
                    class="elevation-1"
                  >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-center">{{ props.item.name }}</td>
                    <td class="text-xs-center">{{ props.item.description }}</td>
                    <td class="text-xs-center">
                      <v-checkbox
                        :key="`schedule_item_${props.item.id}`"
                        :name="`check_${props.item.id}`"
                        :input-value="props.item.status"
                        @change="handleCourseScheduleStatus(props.item.id, props.item.status)"
                        color="primary"
                        class="center"
                      ></v-checkbox>
                    </td>
                    <td class="text-xs-center">
                      <v-tooltip top>
                        <v-icon
                          small
                          class="mr-2"
                          @click.prevent="seeScheduleDetail(props.item.id)"
                          slot="activator"
                        >
                          today
                        </v-icon>
                        <span>{{$t('extracurriculares.courses.schedules.schedule_detail')}}</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <v-icon
                          small
                          class="mr-2"
                          @click.prevent="editSchedule(props.item.id)"
                          slot="activator"
                        >
                          edit
                        </v-icon>
                        <span>{{$t('extracurriculares.courses.edit')}}</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <v-icon
                          small
                          class="mr-2"
                          @click.prevent="removeCourseSchedule(props.item.id)"
                          slot="activator"
                        >
                          delete
                        </v-icon>
                        <span>{{$t('extracurriculares.courses.delete')}}</span>
                      </v-tooltip>
                    </td>
                  </template>
                  </v-data-table>

                  <v-card-actions>
                    <v-btn color="primary" flat @click="schedulesDialog=false">{{ $t('close') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </template>
        </v-dialog>
        <v-dialog v-model="scheduleDetailModal" max-width="800px">
          <template>
            <v-layout>
              <v-flex xs12>
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout>
                        <v-flex xs12>
                          <div class="days">
                            <v-checkbox
                              v-for="day in weekDays"
                              :key="`days-${day.value}`"
                              :label="day.text"
                              v-model="scheduleDetForm.days"
                              :value="day.value"
                              color="primary"
                            ></v-checkbox>
                          </div>
                          <has-error :form="scheduleDetForm" field="days"></has-error>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex xs12 sm3 md3>
                          <time-picker
                            :form="scheduleDetForm"
                            :label="$t('extracurriculares.courses.schedules.time_from')"
                            :v-errors="errors"
                            :value.sync="scheduleDetForm.time_from"
                            name="time_from"
                            data-vv-scope="schedule_det_form"
                            v-validate="'required'"
                          ></time-picker>
                          <has-error :form="scheduleDetForm" field="time_from"></has-error>
                        </v-flex>
                        <v-flex xs12 sm3 md3>
                          <time-picker
                            :form="scheduleDetForm"
                            :label="$t('extracurriculares.courses.schedules.time_to')"
                            :v-errors="errors"
                            :value.sync="scheduleDetForm.time_to"
                            name="time_to"
                            data-vv-scope="schedule_det_form"
                            v-validate="'required'"
                          ></time-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-btn :loading="loading_schedule_form" :disabled="loading_schedule_form" v-if="!editingScheduleDet" color="primary" @click="saveScheduleDet">{{$t('extracurriculares.courses.registration_dates.add')}}</v-btn>
                          <div v-else>
                            <v-btn :loading="loading_schedule_form" :disabled="loading_schedule_form" color="primary" @click="updateScheduleDet">{{$t('extracurriculares.courses.schedules.update')}}</v-btn>
                            <v-btn color="primary" @click="cancelUpdateScheduleDet">{{$t('extracurriculares.courses.form.cancel')}}</v-btn>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>

                  </v-card-text>
                </v-card>
                <v-card>
                  <v-data-table
                    :headers="headersScheduleDetail"
                    :items="schedule_details"
                    :loading="loadingTable"
                    class="elevation-1"
                  >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-center">{{ $t(`extracurriculares.courses.schedules.days.${props.item.day.substring(0, 3)}`)}}</td>
                    <td class="text-xs-center">{{ props.item.time_from }}</td>
                    <td class="text-xs-center">{{ props.item.time_to }}</td>
                    <td class="text-xs-center">
                      <v-tooltip top>
                        <v-icon
                          small
                          class="mr-2"
                          @click.prevent="editScheduleDet(props.item.id)"
                          slot="activator"
                        >
                          edit
                        </v-icon>
                        <span>{{$t('extracurriculares.courses.edit')}}</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <v-icon
                          small
                          class="mr-2"
                          @click.prevent="removeScheduleDetail(props.item.id)"
                          slot="activator"
                        >
                          delete
                        </v-icon>
                        <span>{{$t('extracurriculares.courses.delete')}}</span>
                      </v-tooltip>
                    </td>
                  </template>
                  </v-data-table>
                  <v-card-actions>
                    <v-btn color="primary" flat @click="scheduleDetailModal=false">{{ $t('close') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </template>
        </v-dialog>
        <v-dialog v-model="teachersDialog" max-width="800px">
          <template>
            <v-layout>
              <v-flex xs12>
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                          <select-input
                            :form="courseTeachersForm"
                            :items="this.teachers"
                            :label="$t('extracurriculares.courses.teachers_modal.teacher')"
                            :v-errors="errors"
                            :value.sync="courseTeachersForm.teacher_id"
                            name="teacher_id"
                            data-vv-scope="teachers_form"
                            v-validate="'required'"
                        ></select-input>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <select-input
                            :form="courseTeachersForm"
                            :items="this.schedules"
                            :label="$t('extracurriculares.courses.teachers_modal.schedule')"
                            :v-errors="errors"
                            :value.sync="courseTeachersForm.schedule_id"
                            name="schedule_id"
                            data-vv-scope="teachers_form"
                            v-validate="'required'"
                        ></select-input>
                        </v-flex>

                        <v-flex xs12 sm6 md4>
                          <v-btn color="primary" @click="saveCourseTeacher">{{$t('extracurriculares.courses.teachers_modal.assign')}}</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
                <v-card>
                  <v-card-text>
                    <v-data-table
                      :headers="headersTeachers"
                      :items="teachers_detail"
                      :loading="loadingTable"
                      class="elevation-1"
                    >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-center">{{ props.item.teacher}}</td>
                      <td class="text-xs-center">{{ props.item.schedule }}</td>
                      <td class="text-xs-center">
                        <v-tooltip top>
                          <v-icon
                            small
                            class="mr-2"
                            @click.prevent="removeTeacherCourse(props.item.id)"
                            slot="activator"
                          >
                            delete
                          </v-icon>
                          <span>{{$t('extracurriculares.courses.delete')}}</span>
                        </v-tooltip>
                      </td>
                    </template>
                    </v-data-table>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="primary" flat @click="teachersDialog=false">{{ $t('close') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </template>
        </v-dialog>
        <v-dialog v-model="regsitrationDialog" max-width="900px">
          <template>
            <v-layout>
              <v-flex xs12>
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout row>
                        <v-flex xs12 sm6 md4>
                          <date-picker
                            :form="registrationDatesForm"
                            :label="$t('extracurriculares.courses.registration_dates.start_date')"
                            :v-errors="errors"
                            :value.sync="registrationDatesForm.start_date"
                            name="start_date"
                            v-validate="'required'"
                            data-vv-scope="registration_dates_form"
                          ></date-picker>
                          <has-error :form="registrationDatesForm" field="start_date"></has-error>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <date-picker
                            :form="registrationDatesForm"
                            :label="$t('extracurriculares.courses.registration_dates.end_date')"
                            :v-errors="errors"
                            :value.sync="registrationDatesForm.end_date"
                            name="end_date"
                            v-validate="'required'"
                            data-vv-scope="registration_dates_form"
                          ></date-picker>
                        </v-flex>

                        <v-flex xs12 sm6 md4>
                          <date-picker
                            :form="registrationDatesForm"
                            :label="$t('extracurriculares.courses.registration_dates.course_start_date')"
                            :v-errors="errors"
                            :value.sync="registrationDatesForm.course_start_date"
                            name="course_start_date"
                            v-validate="'required'"
                            data-vv-scope="registration_dates_form"
                          ></date-picker>
                          <has-error :form="registrationDatesForm" field="course_start_date"></has-error>
                        </v-flex>

                      </v-layout>
                      <v-layout row wrap>
                          <v-flex xs12 sm6 md4>
                            <number-input
                              :form="registrationDatesForm"
                              :label="$t('extracurriculares.courses.registration_dates.days_to_pay')"
                              :v-errors="errors"
                              :value.sync="registrationDatesForm.days_to_pay"
                              name="days_to_pay"
                              v-validate="'required'"
                              data-vv-scope="registration_dates_form"
                            ></number-input>
                          </v-flex>
                        <v-flex xs12 sm6 md4>
                          <number-input
                            :form="registrationDatesForm"
                            :label="$t('extracurriculares.courses.registration_dates.term')"
                            :v-errors="errors"
                            :value.sync="registrationDatesForm.term"
                            name="term"
                            v-validate="'required'"
                            data-vv-scope="registration_dates_form"
                          ></number-input>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-btn :loading="loading_registration_form" :disabled="loading_registration_form" v-if="!editingRegistrationDate" color="primary" @click="saveRegistrationDate">{{$t('extracurriculares.courses.registration_dates.add')}}</v-btn>
                          <div v-else>
                            <v-btn :loading="loading_registration_form" :disabled="loading_registration_form" color="primary" @click="updateRegistrationDate">{{$t('extracurriculares.courses.schedules.update')}}</v-btn>
                            <v-btn color="primary" @click="cancelUpdateRegistrationDate">{{$t('extracurriculares.courses.form.cancel')}}</v-btn>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
                <v-card>
                  <v-card-text>
                    <v-card-title>
                      <v-layout row wrap>
                        <v-flex xs3 px-1>
                          <v-select
                            v-model="status_filter_dates"
                            :items="status_items"
                            :label="$t('extracurriculares.courses.form.status')"
                            clearable
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-card-title>
                    <v-data-table
                      :headers="headersRegistrationDates"
                      :items="dates_to_show"
                      :loading="loadingTable"
                      class="elevation-1"
                    >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-center">{{ props.item.start_date}}</td>
                      <td class="text-xs-center">{{ props.item.end_date }}</td>
                      <td class="text-xs-center">{{ props.item.days_to_pay }}</td>
                      <td class="text-xs-center">{{ props.item.course_start_date }}</td>
                      <td class="text-xs-center">{{ props.item.term }}</td>
                      <td class="text-xs-center">{{ $t(`extracurriculares.courses.registration_dates.status_text.${props.item.status}`) }}</td>
                      <td class="text-xs-center">
                        <v-tooltip v-if="props.item.status == 1" top>
                          <v-icon
                            small
                            color="red"
                            class="mr-2"
                            @click.prevent="closeRegistrationDateValidation(props.item.id)"
                            slot="activator"
                          >
                            close
                          </v-icon>
                          <span>{{$t('extracurriculares.courses.close_date')}}</span>
                        </v-tooltip>
                        <v-tooltip v-else top>
                          <v-icon
                            small
                            color="green"
                            class="mr-2"
                            @click.prevent="openRegistrationDate(props.item.id)"
                            slot="activator"
                          >
                            check
                          </v-icon>
                          <span>{{$t('extracurriculares.courses.open_date')}}</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <v-icon
                            small
                            class="mr-2"
                            @click.prevent="editRegistrationDate(props.item.id)"
                            slot="activator"
                          >
                            edit
                          </v-icon>
                          <span>{{$t('extracurriculares.courses.edit')}}</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <v-icon
                            small
                            class="mr-2"
                            @click.prevent="removeRegistrationDate(props.item.id)"
                            slot="activator"
                          >
                            delete
                          </v-icon>
                          <span>{{$t('extracurriculares.courses.delete')}}</span>
                        </v-tooltip>
                      </td>
                    </template>
                    </v-data-table>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="primary" flat @click="regsitrationDialog=false">{{ $t('close') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </template>
        </v-dialog>
        <v-dialog
          v-model="confirm_dialog"
          max-width="290"
        >
          <v-card>
            <v-card-title class="headline">¿ Está seguro que desea cerrar esta fecha de registro ?</v-card-title>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                @click="closeRegistrationDate"
              >
                Si
              </v-btn>

              <v-btn
                color="success"
                @click="confirm_dialog = false"
              >
                No
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import Form from 'vform';
import FileUpload from 'vue-upload-component'
import { VMoney } from 'v-money'
export default {
  name: 'extracurriculares-courses-view',
  directives: {money: VMoney},
  components: {
    FileUpload,
  },
  data() {
    return {
      money: {
          decimal: ',',
          thousands: '.',
          prefix: '$ ',
          suffix: '',
          precision: 0,
          masked: false
      },
      headers: [
        { text: this.$t('extracurriculares.courses.form.type'), align: 'center', value: 'name' },
        { text: this.$t('extracurriculares.courses.form.name'), align: 'center', value: 'status' },
        { text: this.$t('extracurriculares.courses.form.periodicity'), align: 'center', value: 'status' },
        { text: this.$t('extracurriculares.courses.form.price'), align: 'left', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.form.employee_discount'), align: 'left', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.form.quota'), align: 'left', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.form.grades'), align: 'left', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.form.is_public'), align: 'left', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.form.status'), align: 'left', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.form.actions'), align: 'left', value: 'start_date', sortable: false },
      ],
      courses: [],
      courses_to_show: [],
      status_items: [
        { value: 1, text: 'Activo' },
        { value: 0, text: 'Inactivo' },
      ],
      search_filter: '',
      type_filter: '',
      grade_filter: '',
      status_filter: '',
      status_filter_schedules: '',
      status_filter_dates: '',
      editedIndex: -1,
      isLoading: false,
      loadingTable: false,
      dialog: false,
      form: new Form({
        course_type_id: '',
        name: '',
        eng_name: '',
        price: 0,
        quota: '',
        grades_select: [],
        ages: [],
        grades: [],
        description: '',
        eng_description: '',
        clothes: [],
        status: true,
        no_validation: false,
        exclusion_type: '',
        is_public: '',
        siesa_name: '',
        siesa_cc: '',
        siesa_co: '',
        siesa_seller: '',
        siesa_seller_id: '',
        siesa_seller_tercero_id: '',
        siesa_service_id: '',
        siesa_id_un: '',
        siesa_id_motivo: '',
        prerequisite_id: '',
        employee_discount: 0,
        early_payment_discount: 0,
        general_discount: 0,
        provider_payment: '',
        periodicity: '',
        periodicity_number: '',
      }),
      photos: [],
      videos: [],
      showSucessMessage: false,
      editingcourses: false,
      courses_files: [],
      filesDialog: false,
      course_types: [],
      course_types_items: [],
      clothes: [],
      clothes_items: [],
      age_range: [3, 5],
      grades: [],
      showPhotos: false,
      clothesDialog: false,
      headersClothes: [
        { text: this.$t('extracurriculares.clothes.form.name'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.form.actions'), align: 'center', value: 'start_date', sortable: false },
      ],
      course_clothes: [],
      course_needs_price: false,
      teachersDialog: false,
      schedulesDialog: false,
      headersSchedules: [
        { text: this.$t('extracurriculares.courses.schedules.name'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.schedules.description'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.schedules.status'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.schedules.actions'), align: 'center', value: 'start_date', sortable: false },
      ],
      course_schedules: [],
      schedules_to_show: [],
      scheduleForm: new Form({
        course_id: '',
        name: '',
        eng_name: '',
        description: '',
        status: true,
        transfer: false,

      }),
      scheduleDetailModal: false,
      headersScheduleDetail: [
        { text: this.$t('extracurriculares.courses.schedules.day'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.schedules.time_from'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.schedules.time_to'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.schedules.actions'), align: 'center', value: 'start_date', sortable: false }
      ],
      schedule_details: [],
      scheduleDetForm: new Form({
        days: [],
        time_from: '',
        time_to: '',
        schedule_id: ''
      }),
      weekDays: [
        { value: 'monday', text: this.$t('extracurriculares.courses.schedules.days.mon') },
        { value: 'tuesday', text: this.$t('extracurriculares.courses.schedules.days.tue') },
        { value: 'wednesday', text: this.$t('extracurriculares.courses.schedules.days.wed') },
        { value: 'thursday', text: this.$t('extracurriculares.courses.schedules.days.thu') },
        { value: 'friday', text: this.$t('extracurriculares.courses.schedules.days.fri') },
        { value: 'saturday', text: this.$t('extracurriculares.courses.schedules.days.sat') },
        { value: 'sunday', text: this.$t('extracurriculares.courses.schedules.days.sun') },
      ],
      editingSchedule: false,
      courseTeachersForm: new Form({
        course_id: '',
        teacher_id: '',
        schedule_id: '',
      }),
      teachers: [],
      schedules: [],
      headersTeachers: [
        { text: this.$t('extracurriculares.courses.teachers_modal.teacher'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.teachers_modal.schedule'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.teachers_modal.actions'), align: 'center', value: 'start_date', sortable: false }
      ],
      teachers_detail: [],
      regsitrationDialog: false,
      registrationDatesForm: new Form({
        course_id: '',
        start_date: '',
        end_date: '',
        course_start_date: '',
        term: ''
      }),
      headersRegistrationDates: [
        { text: this.$t('extracurriculares.courses.registration_dates.start_date'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.registration_dates.end_date'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.registration_dates.days_to_pay'), align: 'center', value: 'days_to_pay', sortable: false },
        { text: this.$t('extracurriculares.courses.registration_dates.course_start_date'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.registration_dates.term'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.registration_dates.status'), align: 'center', value: 'start_date', sortable: false },
        { text: this.$t('extracurriculares.courses.registration_dates.actions'), align: 'center', value: 'start_date', sortable: false }
      ],
      registration_dates: [],
      dates_to_show: [],
      editingRegistrationDate: false,
      editingScheduleDet: false,
      exclusion_type : [
        { value: "age", text: this.$t("extracurriculares.courses.form.ages") },
        { value: "grade", text: this.$t("extracurriculares.courses.form.grades") },
        { value: "next_grade", text: this.$t("extracurriculares.courses.form.next_grade") }
      ],
      siesa_courses: [],
      sellers: [],
      cc: [],
      motivos: [],
      search_siesa_course: null,
      search_cc: null,
      search_seller: null,
      search_motivo: null,
      loading_courses: false,
      loading_cc: false,
      loading_seller: false,
      loading_motivo: false,
      prerequisite_courses: [],
      schedule_loading: false,
      schedule_det_loading: false,
      loading_registration_form: false,
      loading_schedule_form: false,
      number: {
          decimal: '.',
          thousands: '',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
      },
      periodicity_options : [],
      search_table: '',
      confirm_dialog: false,
      date_to_close: null,
      public_options: [
        { value: 0, text: this.$t("extracurriculares.courses.form.public_options.private") },
        { value: 1, text: this.$t("extracurriculares.courses.form.public_options.public") },
        { value: 2, text: this.$t("extracurriculares.courses.form.public_options.both") }
      ]
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    'form.course_type_id': function (val) {
      let course_type = this.course_types.filter(course_type => course_type.id === val)[0];
      this.course_needs_price = course_type && course_type.payment_type === 'course_payment' ? true : false;
    },
    search_siesa_course (val) {
      val && val !== this.siesa_courses && this.querySiesaCourses(val)
    },
    search_cc (val) {
      val && val !== this.cc && this.queryCC(val)
    },
    search_seller (val) {
      val && val !== this.sellers && this.querySellers(val)
    },
    search_motivo (val) {
      val && val !== this.motivos && this.queryMotivos(val)
    },
    search_filter() {
      this.filter_courses()
    },
    type_filter() {
      this.filter_courses()
    },
    grade_filter() {
      this.filter_courses()
    },
    status_filter() {
      this.filter_courses()
    },
    status_filter_schedules() {
      let schedules_to_show = this.course_schedules

      if (this.status_filter_schedules && this.status_filter_schedules !== '') {
        schedules_to_show = schedules_to_show.filter(schedule => schedule.status === this.status_filter_schedules)
      }
      this.schedules_to_show = schedules_to_show
    },
    status_filter_dates() {
      let dates_to_show = this.registration_dates

      if (this.status_filter_dates && this.status_filter_dates !== '') {
        dates_to_show = dates_to_show.filter(date => date.status === this.status_filter_dates)
      }
      this.dates_to_show = dates_to_show
    },
  },
  created() {
    this.getcourses()
    this.init()
  },
  methods: {
    filter_courses() {
      let courses_to_show = this.courses

      if (this.type_filter && this.type_filter !== '') {
        courses_to_show = courses_to_show.filter(course => course.course_type.id === this.type_filter)
      }

      if (this.search_filter && this.search_filter.trim() !== '') {
        courses_to_show = courses_to_show
          .filter(course => course.name.toUpperCase().indexOf(this.search_filter.toUpperCase()) > -1)
      }

      if (this.status_filter && this.status_filter !== '') {
        courses_to_show = courses_to_show.filter(course => course.status === this.status_filter)
      }

      if (this.grade_filter && this.grade_filter !== '') {
        let course_grades = [];
        let pass_filter = false
        courses_to_show = courses_to_show.filter(course => {
          pass_filter = false
          course_grades = course.grades && course.grades.split(',').map(f => f.trim())
          if (!course_grades) {
            pass_filter = true
          } else {
            if (course_grades.includes(this.grade_filter)) {
              pass_filter = true
            }
          }
          return pass_filter
        })
      }

      this.courses_to_show = courses_to_show
    },
    querySiesaCourses (v) {
        this.loading_courses = true
        this.items = this.siesa_courses.filter(e => {
          return (e.text || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
          })
        this.loading_courses = false
    },
    queryCC (v) {
        this.loading_cc = true
        this.items = this.cc.filter(e => {
          return (e.text || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
          })
        this.loading_cc = false
    },
    querySellers (v) {
        this.loading_seller = true
        this.items = this.sellers.filter(e => {
          return (e.text || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
          })
        this.loading_seller = false
    },
    queryMotivos (v) {
        this.loading_motivo = true
        this.items = this.motivos.filter(e => {
          return (e.text || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
          })
        this.loading_motivo = false
    },
    async getcourses() {
      this.loadingTable = true;
      const { data } = await axios.get('/api/extracurriculares/manage/courses')
      this.courses = data;
      this.courses_to_show = data
      this.loadingTable = false;

      const course_types = await axios.get('/api/extracurriculares/course_types')
      this.course_types = course_types.data;
      course_types.data
        .filter(course_type => course_type.status === true || course_type.status === 1)
        .map(course_type => this.course_types_items.push({ value: course_type.id, text: course_type.name }));

      data.map(prerequisite_course => {
        this.prerequisite_courses.push(
          {
            value: prerequisite_course.id,
            text: prerequisite_course.name
          }
        )
      })


    },
    async init() {
      const clothes = await axios.get('/api/extracurriculares/manage/clothes')
      this.clothes = clothes.data;
      clothes.data
        .filter(clothe => clothe.status === true || clothe.status === 1)
        .map(clothe => this.clothes_items.push({ value: clothe.id, text: clothe.name }));

      const grades = await axios.get('/api/school_grades')
      grades.data
        .map(grade => this.grades.push({ value: grade.name, text: grade.name }));

      const periodicity_options = await axios.get('/api/extracurriculares/periodicity')
      periodicity_options.data
        .map(periodicity => this.periodicity_options.push({ value: periodicity.number, text: periodicity.name }));

      axios.get('/api/siesa/courses')
        .then(resp => {
          if (resp.status === 200) {
            resp.data.courses.map(siesa_course => {
              this.siesa_courses.push(
                {
                  value: siesa_course.id.trim(),
                  text: siesa_course.nombre
                }
              )
            })
          }
        })
        .catch(error => console.log(error));

      axios.get('/api/siesa/sellers')
        .then(resp => {
          if (resp.status === 200) {
            resp.data.sellers.map(seller => {
              this.sellers.push(
                {
                  value: `${seller.tercero_id.trim()}-${seller.vendedor_id.trim()}`,
                  text: `${seller.vendedor_id.trim()} ${seller.razon_social.trim()}`
                }
              )
            })
          }
        })
        .catch(error => console.log(error));

      axios.get('/api/siesa/cc')
        .then(resp => {
          if (resp.status === 200) {
            resp.data.cc.map(cc => {
              this.cc.push(
                {
                  value: `${cc.c_costo_id && cc.c_costo_id.trim()}-${cc.c_operativo_id && cc.c_operativo_id.trim()}-${cc.id_un && cc.id_un.trim()}`,
                  text: `${cc.c_costo_id && cc.c_costo_id.trim()} ${cc.nombre.trim()}`
                }
              )
            })
          }
        })
        .catch(error => console.log(error));

      axios.get('/api/siesa/motivos')
        .then(resp => {
          if (resp.status === 200) {
            resp.data.motivos.map(motivo => {
              this.motivos.push(
                {
                  value: motivo.id,
                  text: `${motivo.id.trim()} ${motivo.nombre.trim()}`
                }
              )
            })
          }
        })
        .catch(error => console.log(error));
    },
    close() {
      this.form.clear();
      this.form.reset();

      this.form = new Form({
        course_type_id: '',
        name: '',
        eng_name: '',
        price: 0,
        quota: '',
        grades_select: [],
        ages: [],
        grades: [],
        description: '',
        eng_description: '',
        clothes: [],
        status: true,
        no_validation: false,
        exclusion_type: '',
        is_public: '',
        siesa_name: '',
        siesa_cc: '',
        siesa_co: '',
        siesa_seller: '',
        siesa_seller_id: '',
        siesa_seller_tercero_id: '',
        siesa_service_id: '',
        siesa_id_un: '',
        siesa_id_motivo: '',
        prerequisite_id: '',
        employee_discount: 0,
        early_payment_discount: 0,
        general_discount: 0,
        provider_payment: '',
        periodicity: '',
        periodicity_number: '',
      })
      this.dialog = false
      this.editingcourses = false
    },
    async savecourses() {

      if (!await this.$validator.validateAll(this.form)) return;

      this.form.grades = this.form.grades_select && this.form.grades_select != '' ? this.form.grades_select.join(', ') : null;
      this.form.ages = this.age_range && this.age_range != '' && this.form.exclusion_type == 'age' ? this.age_range.join(' - ') : null
      const siesa_cc_split = this.form.siesa_cc.split('-')
      const siesa_seller_split = this.form.siesa_seller.split('-')
      this.form.siesa_cc = siesa_cc_split[0];
      this.form.siesa_co = siesa_cc_split[1];
      this.form.siesa_id_un = siesa_cc_split[2];
      this.form.siesa_seller_tercero_id = siesa_seller_split[0]
      this.form.siesa_seller_id = siesa_seller_split[1]
      this.form.siesa_name = this.search_siesa_course;
      this.form.periodicity = this.periodicity_options.find(p => p.value === this.form.periodicity_number).text
      const result = await this.form.post('/api/extracurriculares/manage/courses', this.form)

      if (result.status === 200) {
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('extracurriculares.courses.messages.saved_ok'),
          modal: false
        })
        this.uploadVideos(result.data.course_id);
        this.uploadPictures(result.data.course_id);
      }

      this.close()
    },
    editcourses(id_course) {
      const coursesToEdit = this.courses.filter(courses => courses.id === id_course)[0];
      this.editingcourses = true;
      let clothes = [];
      coursesToEdit.clothes.forEach(clothe => {
        clothes.push(clothe.clothe_id);
      })
      this.age_range = coursesToEdit.ages ? coursesToEdit.ages.split('-').map(age => parseInt(age.trim(), 10)) : ''
      const siesa_seller = `${coursesToEdit.siesa_seller_tercero_id && coursesToEdit.siesa_seller_tercero_id.trim()}-${coursesToEdit.siesa_seller_id && coursesToEdit.siesa_seller_id.trim()}`
      const siesa_cc = `${coursesToEdit.siesa_cc && coursesToEdit.siesa_cc.trim()}-${coursesToEdit.siesa_co && coursesToEdit.siesa_co.trim()}-${coursesToEdit.siesa_id_un && coursesToEdit.siesa_id_un.trim()}`
      this.form = new Form({
        course_type_id: coursesToEdit.course_type_id,
        name: coursesToEdit.name,
        eng_name: coursesToEdit.eng_name,
        cc: coursesToEdit.cc,
        price: coursesToEdit.price,
        quota: coursesToEdit.quota,
        exclusion_type: coursesToEdit.exclusion_type,
        grades_select: coursesToEdit.grades ? coursesToEdit.grades.split(',').map(grade => grade.trim()) : '',
        description: coursesToEdit.description,
        eng_description: coursesToEdit.eng_description,
        clothes,
        status: coursesToEdit.status == 1 ? true : false,
        no_validation: coursesToEdit.no_validation == 1 ? true : false,
        id: coursesToEdit.id,
        is_public: coursesToEdit.is_public,
        siesa_cc,
        siesa_seller,
        siesa_service_id: coursesToEdit.siesa_service_id,
        prerequisite_id: coursesToEdit.prerequisite_id,
        siesa_id_motivo: coursesToEdit.siesa_id_motivo,
        siesa_id_un: coursesToEdit.siesa_id_un,
        employee_discount: coursesToEdit.employee_discount,
        early_payment_discount: coursesToEdit.early_payment_discount,
        general_discount: coursesToEdit.general_discount,
        provider_payment: coursesToEdit.provider_payment == 1 ? true : false,
        periodicity: coursesToEdit.periodicity,
        periodicity_number: coursesToEdit.periodicity_number,
      });
      this.dialog = true;

    },
    deleteCourses(id_course) {
      axios.delete(`/api/extracurriculares/manage/courses/${id_course}`)
        .then(resp => {
          if (resp.status === 200) {
            this.courses = this.courses
              .filter(courses => courses.id !== id_course);
          }
        })
        .catch(error => console.log(error));
    },
    async updateCourseType() {

      if (!await this.$validator.validateAll(this.form)) return;

      this.form.grades = this.form.grades_select && this.form.grades_select != '' ? this.form.grades_select.join(', ') : null;
      this.form.ages = this.age_range && this.age_range != '' && this.form.exclusion_type == 'age' ? this.age_range.join(' - ') : null
      const siesa_cc_split = this.form.siesa_cc.split('-')
      const siesa_seller_split = this.form.siesa_seller.split('-')
      this.form.siesa_cc = siesa_cc_split[0];
      this.form.siesa_co = siesa_cc_split[1];
      this.form.siesa_id_un = siesa_cc_split[2];
      this.form.siesa_seller_tercero_id = siesa_seller_split[0]
      this.form.siesa_seller_id = siesa_seller_split[1]
      this.form.siesa_name = this.search_siesa_course;
      this.form.periodicity = this.periodicity_options.find(p => p.value === this.form.periodicity_number).text
      this.form.put('/api/extracurriculares/manage/courses')
        .then(resp => {
          if (resp.status === 200) {
            this.uploadPictures(this.form.id);
            this.uploadVideos(this.form.id);
            this.dialog = false;
            this.editingcourses = false;
            this.form = new Form({
              course_type_id: '',
              name: '',
              eng_name: '',
              price: '',
              quota: '',
              grades_select: [],
              grades: [],
              ages: [],
              description: '',
              eng_description: '',
              clothes: [],
              status: true,
              no_validation: false,
              exclusion_type: '',
              is_public: '',
              siesa_name: '',
              siesa_cc: '',
              siesa_co: '',
              siesa_seller: '',
              siesa_seller_id: '',
              siesa_seller_tercero_id: '',
              siesa_service_id: '',
              prerequisite_id: '',
              siesa_id_un: '',
              siesa_id_motivo: '',
              employee_discount: 0,
              early_payment_discount: 0,
              general_discount: 0,
              provider_payment: '',
              periodicity: '',
              periodicity_number: '',
            })
          }
        })
        .catch(error => console.log(error));
    },
    handleCourseStatus(id_course, status) {
      axios.put('/api/extracurriculares/manage/courses/state', { id: id_course, status: !status })
        .then(resp => {
          if (resp.status === 200) {
            this.courses = this.courses.map(course => {
              if (course.id === id_course) {
                course.status = !status;
              }
              return course;
            })
          }
        })
    },
    getcoursesizes(sizes) {
      let sizesToShow = [];
      sizes.forEach(size => {
        sizesToShow.push(size.size.name)
      });
      return sizesToShow.join(', ')
    },
    inputFilterVideos(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFileVideos(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log('add', newFile)
      }
      if (newFile && oldFile) {
        // update
        console.log('update', newFile)
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }
    },
    inputFilterPhotos(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFilePhotos(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log('add', newFile)
      }
      if (newFile && oldFile) {
        // update
        console.log('update', newFile)
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }
    },
    uploadPictures(id) {
      let formData = new FormData();
      let fileData;
      if (this.photos.length === 0) {
        this.getcourses()
        return
      };
      this.photos.forEach((file, index) => {
        fileData = this.$refs.photos.get(file.id);
        formData.append(`file_${index}`, fileData.file);
      });
      formData.append('course_id', id);
      formData.append('file_type', 'photo');
      axios.post(`/api/extracurriculares/manage/courses/files`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
        .then(resp => {
          if (resp.status === 200) {
            this.$store.dispatch('responseMessage', {
              type: 'success',
              text: this.$t('extracurriculares.courses.messages.files_saved'),
              modal: false
            })
            this.$refs.photos.clear();
            this.getcourses()
          }
        })
        .catch(error => console.log(error));
    },
    uploadVideos(id) {
      let formData = new FormData();
      let fileData;
      if (this.videos.length === 0) {
        this.getcourses()
        return
      };
      this.videos.forEach((file, index) => {
        fileData = this.$refs.videos.get(file.id);
        formData.append(`file_${index}`, fileData.file);
      });
      formData.append('course_id', id);
      formData.append('file_type', 'video');
      axios.post(`/api/extracurriculares/manage/courses/files`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
        .then(resp => {
          if (resp.status === 200) {
            this.$store.dispatch('responseMessage', {
              type: 'success',
              text: this.$t('extracurriculares.courses.messages.files_saved'),
              modal: false
            })
            this.$refs.videos.clear();
            this.getcourses()
          }
        })
        .catch(error => console.log(error));
    },
    coursesPictures(id) {
      this.filesDialog = true;
      this.courses_files = this.courses
        .filter(course => course.id === id)
        .map(course => course.files)[0]
        .filter(file => file.file_type === 'photo');
      this.showPhotos = true;
    },
    coursesVideos(id) {
      this.filesDialog = true;
      this.courses_files = this.courses
        .filter(course => course.id === id)
        .map(course => course.files)[0]
        .filter(file => file.file_type === 'video');
      this.showPhotos = false;
    },
    courseClothes(id) {
      this.clothesDialog = true;
      this.course_clothes = this.courses
        .filter(course => course.id === id)
        .map(course => course.clothes)[0];
    },
    removeCourseclothe(id) {
      axios.delete(`/api/extracurriculares/manage/courses_clothes/${id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.courses = resp.data;
            this.course_clothes = this.course_clothes.filter(clothe => clothe.id !== id);
          }
        })
        .catch(error => console.log(error));
    },
    async courseTeachers(id) {
      this.teachersDialog = true;
      this.teachers = [];
      this.schedules = [];

      const teachers = await axios.get('/api/extracurriculares/manage/teachers')
      teachers.data.forEach(teacher => {
        this.teachers.push(
          {
            value: teacher.id,
            text: teacher.company.name === teacher.name ? teacher.name : `${teacher.company.name} - ${teacher.name}`
          }
        )
      })
      this.courses
        .filter(course => course.id === id)
        .map(course => {
          course.active_schedules.forEach(schedule => {
            this.schedules.push({
              value: schedule.id,
              text: schedule.name
            })
          })
        })

      this.course_schedules = this.courses
        .filter(course => course.id === id)
        .map(course => course.schedules)[0];

      let schedule = '';
      this.teachers_detail = [];
      this.courses.filter(course => course.id === id)
        .map(course => {
          course.teachers.forEach(teacher => {
            // this.teachers = this.teachers.filter(teacherFilter => teacherFilter.value !== teacher.teacher_id);
            schedule = this.course_schedules
              .filter(schedule => schedule.id === teacher.schedule_id)[0];
            this.teachers_detail.push(
              {
                id: teacher.id,
                teacher: teacher.teacher.name,
                schedule: schedule ? schedule.name : ''
              }
            )
          })
        })


      this.courseTeachersForm = new Form({
        course_id: id,
        teacher_id: '',
        schedule_id: ''
      });

    },
    courseSchedule(id) {
      this.schedulesDialog = true;
      this.course_schedules = this.courses
        .filter(course => course.id === id)
        .map(course => course.schedules)[0];
      this.schedules_to_show = this.courses
        .filter(course => course.id === id)
        .map(course => course.schedules)[0];
      this.scheduleForm = new Form({
        course_id: id,
        name: '',
        eng_name: '',
        description: '',
        status: true,
        transfer: false
      })
    },
    editSchedule(id) {
      const schedule_details = this.course_schedules
        .filter(schedule => schedule.id === id)[0];
      this.editingSchedule = true;
      const course_id = this.scheduleForm.course_id;
      this.scheduleForm = new Form({
        id,
        course_id,
        name: schedule_details.name,
        eng_name: schedule_details.eng_name,
        description: schedule_details.description,
        status: schedule_details.status == 1 ? true : false,
        transfer: false
      })
    },
    cancelUpdateSchedule() {
      const course_id = this.scheduleForm.course_id;
      this.editingSchedule = false;
      this.scheduleForm = new Form({
        course_id,
        name: '',
        eng_name: '',
        description: '',
        status: true,
        transfer: false
      })
    },
    async updateSchedule() {
      const valid = await this.$validator.validateAll('schedule_form')
      if (!valid) return;
      const course_id = this.scheduleForm.course_id;
      axios.put('/api/extracurriculares/manage/courses/schedule', this.scheduleForm)
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data.reserved) {
              this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: this.$t('extracurriculares.courses.messages.schedule_reserved'),
                modal: false
              })
              return
            }
            this.courses = resp.data
            this.course_schedules = this.courses
              .filter(course => course.id === course_id)
              .map(course => course.schedules)[0];
            this.editingSchedule = false;
            this.scheduleForm = new Form({
              course_id,
              name: '',
              eng_name: '',
              description: '',
              status: true
            })
          }
        })
        .catch(error => console.log(error));
    },
    removeCourseSchedule(id) {
      this.editingSchedule = false;
      const course_id = this.scheduleForm.course_id;
      axios.delete(`/api/extracurriculares/manage/courses/schedule/${id}`)
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data.reserved) {
              this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: this.$t('extracurriculares.courses.messages.schedule_reserved'),
                modal: false
              })
              return
            }
            this.courses = resp.data
            this.course_schedules = this.courses
              .filter(course => course.id === course_id)
              .map(course => course.schedules)[0];
            this.scheduleForm = new Form({
              course_id,
              name: '',
              eng_name: '',
              description: '',
              status: true,
              transfer: false
            })
          }
        })
    },
    async saveSchedule() {
      const valid = await this.$validator.validateAll('schedule_form')
      if (!valid) return;
      this.schedule_loading = true
      const id = this.scheduleForm.course_id;
      axios.post('/api/extracurriculares/manage/courses/schedule', this.scheduleForm)
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data.reserved) {
              this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: this.$t('extracurriculares.courses.messages.schedule_reserved'),
                modal: false
              })
              return
            }
            this.courses = resp.data
            this.course_schedules = this.courses
              .filter(course => course.id === id)
              .map(course => course.schedules)[0];
            this.scheduleForm = new Form({
              course_id: id,
              name: '',
              eng_name: '',
              description: '',
              status: true,
              transfer: false
            })
            this.schedule_loading = false
          }
        })
        .catch(error => {
          this.schedule_loading = false
          console.log(error)
        });
    },
    handleCourseScheduleStatus(id, status) {
      const course_id = this.scheduleForm.course_id;
      axios.put('/api/extracurriculares/manage/courses/schedule', { id, status: !status })
        .then(resp => {
          if (resp.status === 200) {
            this.courses = resp.data
            this.course_schedules = this.courses
              .filter(course => course.id === course_id)
              .map(course => course.schedules)[0];
          }
        })
    },
    seeScheduleDetail(id) {
      this.scheduleDetailModal = true;
      this.schedule_details = this.course_schedules
        .filter(schedule => schedule.id === id)
        .map(schedule => schedule.details)[0];
      this.scheduleDetForm = new Form({
        days: [],
        time_from: '',
        time_to: '',
        schedule_id: id
      })

    },
    async saveScheduleDet() {

      let valid = await this.$validator.validateAll('schedule_det_form')
      if (!valid) return;

      valid = this.scheduleDetForm.time_from < this.scheduleDetForm.time_to

      if (!valid) {
        this.scheduleDetForm.errors.set({
          time_from: "La hora inicial no puede ser mayor que la final"
        })

        return
      }

      valid = this.scheduleDetForm.days.length > 0

      if (!valid) {
        this.scheduleDetForm.errors.set({
          days: "Debe seleccionar por lo menos un día"
        })
        return
      }

      const course_id = this.scheduleForm.course_id;
      const id = this.scheduleDetForm.schedule_id;
      axios.post('/api/extracurriculares/manage/courses/schedule/detail', this.scheduleDetForm)
        .then(resp => {
          if (resp.status === 200) {
            this.courses = resp.data
            this.course_schedules = this.courses
              .filter(course => course.id === course_id)
              .map(course => course.schedules)[0];
            this.schedule_details = this.course_schedules
              .filter(schedule => schedule.id === id)
              .map(schedule => schedule.details)[0];
            this.scheduleDetForm = new Form({
              days: [],
              time_from: '',
              time_to: '',
              schedule_id: id
            })
          }
        })
        .catch(error => console.log(error));
    },
    editScheduleDet(id) {
      const course_id = this.scheduleForm.course_id;
      const schedule_details = this.schedule_details
        .filter(schedule => schedule.id === id)[0];
      this.editingScheduleDet = true;
      console.log(JSON.stringify(schedule_details));
      this.scheduleDetForm = new Form({
        id,
        days: schedule_details.day,
        time_from: schedule_details.time_from,
        time_to: schedule_details.time_to,
        schedule_id: schedule_details.schedule_id,
        course_id: course_id
      })
    },
    cancelUpdateScheduleDet() {
      this.editingScheduleDet = false;
      const schedule_id = this.registrationDatesForm.schedule_id;
      this.scheduleDetForm = new Form({
        days: [],
        time_from: '',
        time_to: '',
        schedule_id: schedule_id
      })
    },
    async updateScheduleDet() {
      this.loading_schedule_form = true;

      let valid = await this.$validator.validateAll('schedule_det_form')
      if (!valid) {
        this.loading_schedule_form = false;
        return;
      }

      valid = this.scheduleDetForm.time_from < this.scheduleDetForm.time_to

      if (!valid) {
        this.loading_schedule_form = false;
        this.scheduleDetForm.errors.set({
          time_from: "La hora inicial no puede ser mayor que la final"
        })

        return
      }

      valid = this.scheduleDetForm.days.length > 0

      if (!valid) {
        this.loading_schedule_form = false;
        this.scheduleDetForm.errors.set({
          days: "Debe seleccionar por lo menos un día"
        })
        return
      }

      const course_id = this.scheduleForm.course_id;
      const id = this.scheduleDetForm.schedule_id;
      axios.put('/api/extracurriculares/manage/courses/schedule/detail', this.scheduleDetForm)
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data.reserved) {
              this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: this.$t('extracurriculares.courses.messages.schedule_reserved'),
                modal: false
              })
              this.loading_schedule_form = false;
              return
            } else {
              this.courses = resp.data
              this.course_schedules = this.courses
                .filter(course => course.id === course_id)
                .map(course => course.schedules)[0];
              this.schedule_details = this.course_schedules
                .filter(schedule => schedule.id === id)
                .map(schedule => schedule.details)[0];
              this.scheduleDetForm = new Form({
                days: [],
                time_from: '',
                time_to: '',
                schedule_id: id
              })
              this.loading_schedule_form = false;
            }
          }
        })
        .catch(error => {
          this.loading_schedule_form = false;
        });
    },
    removeScheduleDetail(id) {
      const course_id = this.scheduleForm.course_id;
      const schedule_id = this.scheduleDetForm.schedule_id;
      axios.delete(`/api/extracurriculares/manage/courses/schedule/detail/${id}`)
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data.reserved) {
              this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: this.$t('extracurriculares.courses.messages.schedule_reserved'),
                modal: false
              })
              return
            }
            this.courses = resp.data
            this.course_schedules = this.courses
              .filter(course => course.id === course_id)
              .map(course => course.schedules)[0];
            this.schedule_details = this.course_schedules
              .filter(schedule => schedule.id === schedule_id)
              .map(schedule => schedule.details)[0];
            this.scheduleDetForm = new Form({
              days: [],
              time_from: '',
              time_to: '',
              schedule_id
            })
          }
        })
    },
    async saveCourseTeacher() {
      const valid = await this.$validator.validateAll('teachers_form');

      if (!valid) return;

      axios.post('/api/extracurriculares/manage/courses/teacher', this.courseTeachersForm)
        .then(resp => {
          if (resp.status === 200) {
            const course_id = this.courseTeachersForm.course_id;
            this.courses = resp.data;
            this.courseTeachers(course_id);
            this.courseTeachersForm = new Form({
              course_id,
              teacher_id: '',
              schedule_id: '',
            })
          }
        })
        .catch(error => console.log(error))
    },
    removeTeacherCourse(id) {
      axios.delete(`/api/extracurriculares/manage/courses/teacher/${id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.teachers_detail = this.teachers_detail.filter(teacher => teacher.id !== id);
            this.courses = resp.data;
          }
        })
        .catch(error => console.log(error))
    },
    courseRegistrationDates(id) {
      this.registration_dates = this.courses.filter(course => course.id === id)
        .map(course => course.registration_dates)[0];
        this.dates_to_show = this.registration_dates;
      this.regsitrationDialog = true;
      this.registrationDatesForm = new Form({
        course_id: id,
        start_date: '',
        end_date: '',
        days_to_pay: '',
        course_start_date: '',
        term: ''
      })

    },
    async saveRegistrationDate() {
      this.loading_registration_form = true;
      let valid = await this.$validator.validateAll('registration_dates_form')
      if (!valid) {
        this.loading_registration_form = false;
        return
      }

      valid = this.registrationDatesForm.end_date > this.registrationDatesForm.start_date

      if (!valid) {
        this.loading_registration_form = false;
        this.registrationDatesForm.errors.set({
          start_date: "La fecha inicial de registro no puede ser mayor que la final"
        })
        return
      }
      valid = this.registrationDatesForm.end_date < this.registrationDatesForm.course_start_date

      if (!valid) {
        this.loading_registration_form = false;
        this.registrationDatesForm.errors.set({
          course_start_date: "La fecha inicial de curso no puede ser mayor que la final de registro"
        })
        return
      }

      this.registration_dates.forEach(registration => {
        if (this.registrationDatesForm.start_date >= registration.start_date &&
          this.registrationDatesForm.start_date <= registration.end_date) {
            valid = false
          }
        if (this.registrationDatesForm.end_date >= registration.start_date &&
          this.registrationDatesForm.end_date <= registration.end_date) {
            valid = false
          }
      })

      if (!valid) {
        this.loading_registration_form = false;
        this.registrationDatesForm.errors.set({
          course_start_date: "Las nuevas fechas entran en conflicto con fechas de registro anteriores"
        })
        return
      }

      axios.post('/api/extracurriculares/manage/courses/registration_dates', this.registrationDatesForm)
        .then(resp => {
          if (resp.status === 200) {
            const course_id = this.registrationDatesForm.course_id;
            this.registration_dates = resp.data;
            this.dates_to_show = resp.data;
            this.getcourses();
            this.registrationDatesForm = new Form({
              course_id,
              start_date: '',
              end_date: '',
              days_to_pay: '',
              course_start_date: '',
              term: ''
            })
            this.loading_registration_form = false;
          }
        })
        .catch(error => {
          this.loading_registration_form = false;
        });
    },
    editRegistrationDate(id) {
      const registration_details = this.registration_dates
        .filter(registration => registration.id === id)[0];
      this.editingRegistrationDate = true;
      const course_id = this.registrationDatesForm.course_id;
      this.registrationDatesForm = new Form({
        id,
        course_id,
        start_date: registration_details.start_date,
        end_date: registration_details.end_date,
        days_to_pay: registration_details.days_to_pay,
        course_start_date: registration_details.course_start_date,
        term: registration_details.term
      })
    },
    cancelUpdateRegistrationDate() {
      const course_id = this.registrationDatesForm.course_id;
      this.editingRegistrationDate = false;
      this.registrationDatesForm = new Form({
        course_id,
        start_date: '',
        end_date: '',
        days_to_pay: '',
        course_start_date: '',
        term: ''
      })
    },
    async updateRegistrationDate() {
        
      this.loading_registration_form = true;
      let valid = await this.$validator.validateAll('registration_dates_form')
      if (!valid) {
        this.loading_registration_form = false;
        return
      }

      valid = this.registrationDatesForm.end_date > this.registrationDatesForm.start_date

      if (!valid) {
        this.loading_registration_form = false;
        this.registrationDatesForm.errors.set({
          start_date: "La fecha inicial de registro no puede ser mayor que la final"
        })
        return
      }
      valid = this.registrationDatesForm.end_date < this.registrationDatesForm.course_start_date

      if (!valid) {
        this.loading_registration_form = false;
        this.registrationDatesForm.errors.set({
          course_start_date: "La fecha inicial de curso no puede ser mayor que la final de registro"
        })
        return
      }

      this.registration_dates.forEach(registration => {
        if (registration.id != this.registrationDatesForm.id) {
          if (this.registrationDatesForm.start_date >= registration.start_date &&
            this.registrationDatesForm.start_date <= registration.end_date) {
              valid = false
            }
          if (this.registrationDatesForm.end_date >= registration.start_date &&
            this.registrationDatesForm.end_date <= registration.end_date) {
              valid = false
            }
        }
      })

      if (!valid) {
        this.loading_registration_form = false;
        this.registrationDatesForm.errors.set({
          course_start_date: "Las nuevas fechas entran en conflicto con fechas de registro anteriores"
        })
        return
      }

      axios.put('/api/extracurriculares/manage/courses/registration_dates', this.registrationDatesForm)
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data.reserved) {
              this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: this.$t('extracurriculares.courses.messages.registration_dates_update'),
                modal: false
              })
              this.loading_registration_form = false;
              return
            } else {
              const course_id = this.registrationDatesForm.course_id;
              this.registration_dates = resp.data;
              this.dates_to_show = resp.data;
              this.getcourses();
              this.registrationDatesForm = new Form({
                course_id,
                start_date: '',
                end_date: '',
                days_to_pay: '',
                course_start_date: '',
                term: ''
              })
              this.loading_registration_form = false;
            }
          }
        })
        .catch(error => {
          this.loading_registration_form = false;
        });
    },
    removeRegistrationDate(id) {
      this.editingRegistrationDate = false;
      axios.delete(`/api/extracurriculares/manage/courses/registration_dates/${id}`)
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data.reserved) {
              this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: this.$t('extracurriculares.courses.messages.registration_dates_reserved'),
                modal: false
              })
              return
            }
            this.registration_dates = this.registration_dates.filter(date => date.id !== id);
            this.dates_to_show = this.registration_dates;
            this.getcourses();
          }
        })
    },
    deleteCourseFile(file_id) {
      axios.delete(`/api/extracurriculares/manage/courses/file/${file_id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.courses_files = this.courses_files.filter(file => file.id !== file_id);
            this.getcourses();
          }
        })
    },
    formatNumber(number) {
      if(!number || typeof number === 'undefined') {
          return 0;
      } else {
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    clean() {
      this.form = new Form({
        course_type_id: '',
        name: '',
        price: '',
        quota: '',
        grades_select: [],
        ages: [],
        grades: [],
        description: '',
        clothes: [],
        status: true,
        no_validation: false,
        exclusion_type: '',
        is_public: '',
        siesa_name: '',
        siesa_cc: '',
        siesa_co: '',
        siesa_seller: '',
        siesa_seller_id: '',
        siesa_seller_tercero_id: '',
        siesa_service_id: '',
        prerequisite_id: '',
        siesa_id_un: '',
        siesa_id_motivo: '',
        employee_discount: 0,
        early_payment_discount: 0,
        general_discount: 0,
        provider_payment: '',
        periodicity: '',
        periodicity_number: '',
      })
    },
    getCourseName(id) {
      if (!id) {
        return ''
      }
      return this.courses.find(course => course.id == id).name
    },
    closeRegistrationDateValidation(id) {
      this.date_to_close = id
      this.confirm_dialog = true
    },
    closeRegistrationDate() {
      axios.post('/api/extracurriculares/manage/courses/registration_dates/close', { id: this.date_to_close })
        .then(resp => {
          if (resp.status === 200) {
            this.registration_dates = this.registration_dates.map(reg => {
              if (reg.id === this.date_to_close) {
                reg.status = 2
              }
              return reg
            })
            this.date_to_close = null
            this.confirm_dialog = false
            this.dates_to_show = this.registration_dates;
          }
        })
        .catch(error => console.log(error))
    },
    openRegistrationDate(id) {
      axios.post('/api/extracurriculares/manage/courses/registration_dates/open', { id })
        .then(resp => {
          if (resp.status === 200) {
            this.registration_dates = this.registration_dates.map(reg => {
              if (reg.id === id) {
                reg.status = 1
              }
              return reg
            })
            this.dates_to_show = this.registration_dates;
          }
        })
        .catch(error => console.log(error))
    }
  }
}
</script>
<style>
.center {
  text-align: center;
  vertical-align: middle;
  justify-content: center;
  align-content: center;
  align-items: center;
}
span.v-btn {
  display: flex;
}
.icons {
  display: flex;
  flex-wrap: wrap;
}
.days {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/manage_columbus/courses.vue